import React from "react";
import { useTranslation } from "react-i18next";
import {
  UpfrontPaymentButtonRow,
  UpfrontPaymentFinancialReceipt,
  UpfrontPaymentFinancialReceiptTitle,
  UpfrontPaymentFinancialWarningRoundedWrapper,
} from "../UpfrontPayment.styles";
import { useDeviceHook } from "../../../utils/hooks/useDeviceHook";
import {
  getCentsToDollars,
  UpfrontPaymenFinancialAssistanceResponse,
} from "../Services/UpfrontPaymentService";
import { WarningRounded } from "../../../assets/iconComponents/WarningRounded";
import { BillingSupportNumber } from "../types";
import { Button } from "../../shared/Button/Button";
import { GreenFullCheckIcon } from "../../../assets/iconComponents/GreenFullCheckIcon";
import UpfrontPaymentPhoneLink from "../UpfrontPaymentPhoneLink";

interface StepQualificationProps {
  financialAidResponse: UpfrontPaymenFinancialAssistanceResponse;
  setStripeModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFinancialAssistanceModalOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  medicaidStatus: "Yes" | "No" | null;
}

const StepQualification: React.FC<StepQualificationProps> = ({
  financialAidResponse,
  setStripeModalOpen,
  setFinancialAssistanceModalOpen,
  medicaidStatus,
}) => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();
  const qualifiedSubtext =
    medicaidStatus === "No"
      ? t("upfrontPayment.financialAssistance.qualifiedAutoApproved")
      : t("upfrontPayment.financialAssistance.qualifiedThanks", {
          infoType: t("upfrontPayment.main.insurance").toLowerCase(),
        });
  return (
    <UpfrontPaymentFinancialReceipt deviceType={deviceType}>
      {financialAidResponse?.is_qualified ? (
        <GreenFullCheckIcon />
      ) : (
        <UpfrontPaymentFinancialWarningRoundedWrapper>
          <WarningRounded />
        </UpfrontPaymentFinancialWarningRoundedWrapper>
      )}
      <UpfrontPaymentFinancialReceiptTitle>
        {financialAidResponse?.is_qualified ? (
          <>
            <span>
              {t("upfrontPayment.financialAssistance.qualifiedTitle")}
            </span>
            <span>
              {t("upfrontPayment.financialAssistance.qualifiedBillNow", {
                amount: getCentsToDollars(financialAidResponse?.bill.balance),
              })}
            </span>
          </>
        ) : (
          t("upfrontPayment.financialAssistance.notQualifiedTitle")
        )}
      </UpfrontPaymentFinancialReceiptTitle>
      <div
        style={{
          display: "inline",
          fontSize: "16px",
          fontFamily: "light",
        }}
      >
        {financialAidResponse?.is_qualified ? (
          qualifiedSubtext
        ) : (
          <>
            {t("upfrontPayment.financialAssistance.notQualifiedPrefix")}
            <UpfrontPaymentPhoneLink />
            {t("upfrontPayment.paymentPlan.helpSuffix")}{" "}
          </>
        )}
      </div>
      <UpfrontPaymentButtonRow>
        <Button
          label={
            financialAidResponse?.is_qualified &&
            financialAidResponse?.bill.balance > 0
              ? t("upfrontPayment.actions.payAmount", {
                  amount: getCentsToDollars(financialAidResponse?.bill.balance),
                })
              : t("upfrontPayment.actions.done")
          }
          onClick={() => {
            setFinancialAssistanceModalOpen(false);
            if (
              financialAidResponse?.is_qualified &&
              financialAidResponse?.bill.balance > 0
            ) {
              setStripeModalOpen(true);
            }
          }}
          size="medium"
          backgroundColor="greenDark"
        />
      </UpfrontPaymentButtonRow>
    </UpfrontPaymentFinancialReceipt>
  );
};

export default StepQualification;
